import { DEFAULT_LANGUAGE, getPortalCopy } from "../i18n";

export const specialtyLabel = (value, language = DEFAULT_LANGUAGE) => {
  if (!value) return "—";
  const specialties = getPortalCopy(language).profile.specialties;
  return specialties?.[value] ?? value;
};
